import { chakra } from "@chakra-ui/react";

export const BaseIcon = chakra("svg", {
  baseStyle: {
    fill: "currentColor",
    height: "1em",
    width: "1em",
  },
});
